export default __webpack_public_path__ + "static/media/open-external.279c497f.svg";